import { useState, useEffect } from 'react';
import { lsGet, lsSet } from '../lib/storage';

function SunIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

export default function ThemeToggle({ inline = false }) {
  const [isLight, setIsLight] = useState(() => {
    const stored = lsGet('al-diwan-theme');
    return stored !== 'dark';
  });

  useEffect(() => {
    if (isLight) {
      document.body.classList.add('theme-light');
      lsSet('al-diwan-theme', 'light');
    } else {
      document.body.classList.remove('theme-light');
      lsSet('al-diwan-theme', 'dark');
    }
  }, [isLight]);

  // Apply saved theme on first mount
  useEffect(() => {
    const stored = lsGet('al-diwan-theme');
    if (!stored || stored === 'light') {
      document.body.classList.add('theme-light');
    }
  }, []);

  return (
    <button
      className={inline ? 'theme-toggle-inline' : 'theme-toggle'}
      aria-label={isLight ? 'Switch to dark theme' : 'Switch to light theme'}
      onClick={() => setIsLight(v => !v)}
    >
      {isLight ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
